export const COMMUNITY_GROUPS_ROUTE_VIEW_PARAM = 'groups';
export const COMMUNITY_INSTITUTIONS_ROUTE_VIEW_PARAM = 'institutions';
export const COMMUNITY_PEOPLE_ROUTE_VIEW_PARAM = 'people';
